// ** React Imports
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';

// ** Reactstrap Imports
import {
    Col,
    Container,
    Row
} from 'reactstrap';

// Utility-Service
import Segwitz from '../../../assets/images/Segwitz.png';
import { getToken } from '../../../utility/AuthService';
import { CurrentYear } from '../../../utility/helper';

// API-Service
// import { getSingleDataService } from '../../../services/postService'

// Redux-Settings
// import {
//     selectPostDetail,
//     setSingleData,
// } from '../../../redux/slices/postSlice'

const FooterPage = () => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    // const Detail = useSelector(selectPostDetail)
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const token = getToken()
    const navigate = useNavigate()
    const { id } = useParams()

    return (
        <>
            <Container className='mt-auto'>
                <Row>
                    <Col className='d-flex flex-wrap align-items-center justify-content-center justify-content-lg-between my-3' xs='12'>
                        <p className='text-center mb-0'>Copyright © {CurrentYear} UN Global Compact Network Malaysia & Brunei. All Rights Reserved.</p>
                        <div className='d-flex flex-column align-items-center mt-3 mt-lg-0'>
                            <span className='text-primary'>Technology Partner</span>
                            <Link target="_blank" to="https://segwitz.com/">
                                <img className='mt-1 img-fluid' src={Segwitz} />
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>

    )
}

export default FooterPage
